/**
 * [ File :: G_ImageGoal.js ]
 *
 * @경로 : /public/scripts/game/lcPlugIn/canvas/grid/dev/child/image/G_ImageGoal.js
 * @설명 : 목표 객체
 * @진행 : 종료
 * @주의 : inspector(조사자) 객체를 상속 받습니다. - 결국 목표 객체도 캐릭터를 조사하는 것
 * @일자 : 2018.mm.dd
 * @작성 : SuperMoon
 * @참조 :
 */

import G_ImageInspector from 'canvas/grid/dev/child/image/G_ImageInspector';
import B_Define from 'canvas/base/dev/util/B_Define';

const G_ImageGoal = (function() {

	return class extends G_ImageInspector {

		constructor(obj) {
			super(obj);

			// [S] 성공여부
			this._clear = false;
		}

		// @DES :: clear {bool} - 골지점 성공여부
		get clear() { return this._clear; }

		/**
		 * [ Function (protected) :: _checkSolution ]
		 *
		 * @OVERRIDING
		 * @DES :: 목표지점 로직체크
		 * @IP1 :: hero {obj}
		 * @IP2 :: cb {func}
		 */
		_checkSolution(hero, cb) {

			const STATE = this.CODMOS.WORLD.STATE;
			const LIST = this.CODMOS.WORLD.LIST;

			if(!this.clear) {

				// # 1. 출입 제한
				// # 2. 우선 순위
				// # 3. 정답지
				super._checkSolution(hero, ()=>{
					// # 4. 클리어

					// 진행 & 중지 판단
					if(STATE.clear == B_Define.CLEAR_STATUS['GOING']) {
						// [#] 중간에 실패된게 없음
						this._clear = true;
						STATE.going(B_Define.CLEAR_STATUS['SUCCESS'], B_Define.REASON['SUCCESS'], this);

						// # 4. 다른 골지점 비교
						// TODO 목표지점중 'false' 인 것이 있다면 => GOING
						for(let gKey in LIST.goal) {
							if(!LIST.goal[gKey]._clear) STATE.init();
						}
					}
					cb();
				});
			}
			// clear 목표지점 (pass)
			else cb();
		}

	}
}());

export default G_ImageGoal;


// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/canvas/grid/dev/child/image/G_ImageGoal.js